export default "__VITE_ASSET__BsuDwe0L__"